var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c("img", {
            attrs: {
              alt: "GitHub logo",
              src: require("@/assets/img/github-logo.svg"),
              width: "65",
            },
          }),
          _c("hr"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  disabled: !this.vulnsourceEnabled && !this.apitoken,
                  color: "primary",
                  id: "vulnsourceEnabled",
                  label: "",
                },
                model: {
                  value: _vm.vulnsourceEnabled,
                  callback: function ($$v) {
                    _vm.vulnsourceEnabled = $$v
                  },
                  expression: "vulnsourceEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.vulnsource_github_advisories_enable")) +
              "\n    "
          ),
          _c("br"),
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: {
                  color: "primary",
                  id: "aliasSyncEnabled",
                  label: "",
                  title: _vm.$t("admin.vulnsource_alias_sync_enable_tooltip"),
                  disabled: !this.vulnsourceEnabled,
                },
                model: {
                  value: _vm.aliasSyncEnabled,
                  callback: function ($$v) {
                    _vm.aliasSyncEnabled = $$v
                  },
                  expression: "aliasSyncEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.vulnsource_alias_sync_enable")) +
              "\n    "
          ),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "github-advisories-apitoken",
              label: _vm.$t("admin.personal_access_token"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "password",
              lazy: "true",
            },
            model: {
              value: _vm.apitoken,
              callback: function ($$v) {
                _vm.apitoken = $$v
              },
              expression: "apitoken",
            },
          }),
          _c("hr"),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("admin.vulnsource_github_advisories_desc")) +
              "\n  "
          ),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: {
                disabled: this.vulnsourceEnabled && !this.apitoken,
                variant: "outline-primary",
              },
              on: { click: _vm.saveChanges },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("message.update")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }